import React from 'react';
import {withTranslation} from 'react-i18next';
import {Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row} from 'reactstrap';
import TextField from '../components/TextField';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {NotificationManager} from '../components/common/react-notifications';
import Api from '../services/Api';

class DescriptionForm extends React.Component {
  createDescription = async values => {
    const {t, userId} = this.props;
    try {
      await Api.invoke(
        'POST',
        '/admin-ui/user-descriptions',
        {
          ...values,
          userId,
        },
      );
      NotificationManager.success(t('Note created successfully'), t('Message'));
      ModalManager.close({
        isOpen: false
      });
      this.props.fireFetchData();
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  updateDescription = async values => {
    const {t} = this.props;
    try {
      await Api.invoke(
        'PUT',
        '/admin-ui/user-descriptions',
        values,
      );
      NotificationManager.success(t('Note updated successfully'), t('Message'));
      ModalManager.close({
        isOpen: false
      });
      this.props.fireFetchData();
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  render() {
    const {t, note} = this.props;
    return(
      <FinalForm
        onSubmit={note ? this.updateDescription : this.createDescription}
        initialValues={note ?
          {
            id: note.id,
            description: note.description,
          } : undefined
        }
        render={({handleSubmit, submitting, pristine, hasValidationErrors}) => {
          return (
            <Form>
              <Row>
                <Col>
                  <TextField
                    item={{
                      name: 'description',
                      i18n: t('Description'),
                      type: 'textarea',
                      rows: 3,
                    }}
                  />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col>
                  <LoaderButton
                    color="success"
                    onClick={handleSubmit}
                    loading={submitting}
                    disabled={pristine || hasValidationErrors || submitting}
                    className="text-center"
                    style={{minWidth: '100px'}}>
                    {t('Save')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(DescriptionForm);
